import { BitmapText, Container } from '@pixi/react'
import { memo, useMemo } from 'react'
import { GodziSpinType } from '../../domain/godziDrop'
import { SpinePlayer } from '../../UI'

interface GodziSpinButtonProps {
  spinType: GodziSpinType
  freeSpinCount: number
}

export const GodziSpinButton = memo((props: GodziSpinButtonProps) => {
  const godziRoundContent = useMemo(() => {
    return (
      <BitmapText
        key="roundText"
        name="roundText"
        text={props.freeSpinCount.toString()}
        x={0}
        y={75}
        style={{ fontName: 'GodziFont', fontSize: 20, align: 'center' }}
        anchor={[0.5, 2]}
        visible={props.spinType === GodziSpinType.freeSpin}
      />
    )
  }, [props.freeSpinCount, props.spinType])

  if (props.spinType === GodziSpinType.none) return null

  return (
    <Container
      name="GodziSpinButton"
      x={540}
      y={1690}
      scale={1}
    >

      <SpinePlayer
        x={0}
        y={75}
        data="FSbtn.skel"
        atlas="FSbtn.atlas"
        loop={true}
        animationStr={props.spinType}
        scale={1}
      />

      {godziRoundContent}

    </Container>
  )
})
